import { inject, Injectable } from '@angular/core';
import {
  HttpEvent,
  HttpHandler,
  HttpHandlerFn,
  HttpInterceptor,
  HttpInterceptorFn,
  HttpRequest,
} from '@angular/common/http';
import { Observable } from 'rxjs';
import { MobileAppHeadersService } from '@services/mobile-app-headers.service';

@Injectable()
export class MobileAppHeadersInterceptor implements HttpInterceptor {
  constructor(private readonly mobileAppHeaders: MobileAppHeadersService) {}

  intercept(req: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    return next.handle(this.mobileAppHeaders.applyTo(req));
  }
}

export const mobileAppHeadersInterceptor: HttpInterceptorFn = (
  req: HttpRequest<unknown>,
  next: HttpHandlerFn,
): Observable<HttpEvent<unknown>> => {
  const mobileAppHeaders = inject(MobileAppHeadersService);
  return next(mobileAppHeaders.applyTo(req));
};
